export const MAX_DOCUMENT_UPLOAD_FILE_SIZE_BYTES = 30 * 1024 * 1024;

export function isDocumentUploadFileTooLarge(file: File): boolean {
  return file.size > MAX_DOCUMENT_UPLOAD_FILE_SIZE_BYTES;
}
